import _toConsumableArray from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.for-each";
import visit from 'unist-util-visit';
import Slugger from 'github-slugger';
var HEADING_TAG_PATTERN = /^h[1-6]$/;

function fixHeadingLinks(htmlAst) {
  var slugger = new Slugger();
  visit(htmlAst, 'element', function (element) {
    if (HEADING_TAG_PATTERN.test(element.tagName)) {
      var id = element.properties.id;
      var slug = slugger.slug(id);

      if (id !== slug) {
        element.properties.id = slug;
        element.children.forEach(function (child) {
          if (child.type === 'element' && child.tagName === 'a') {
            child.properties.href = "#".concat(slug);
          }
        });
      }
    }
  });
}

function getPageHeadingsAndHtmlAst(page) {
  var headings = _toConsumableArray(page.headings);

  var htmlAst = {
    type: 'root',
    children: _toConsumableArray(page.htmlAst.children)
  };
  var includes = page.frontmatter && page.frontmatter.include;

  if (includes && includes.length) {
    includes.forEach(function (file) {
      var _htmlAst$children;

      if (!file) {
        console.error("Invalid file path in md front matter 'include' property", page);
      }

      if (!file.childMarkdownRemark) {
        console.error("Invalid file in md front matter 'include' property", page);
        return;
      }

      var childMarkdownRemark = file.childMarkdownRemark;
      headings.push.apply(headings, _toConsumableArray(childMarkdownRemark.headings));

      (_htmlAst$children = htmlAst.children).push.apply(_htmlAst$children, _toConsumableArray(childMarkdownRemark.htmlAst.children));
    }); // NOTE: fix heading link after joining md includes

    fixHeadingLinks(htmlAst);
  }

  return {
    headings: headings,
    htmlAst: htmlAst
  };
}

export default getPageHeadingsAndHtmlAst;